module.exports = __webpack_public_path__ + "media/01.2fb7defc.mp3";